<div class="container">
  <div class="error-layout__container">
    <ng-content></ng-content>
  </div>
</div>
